import React, { useEffect, useState, useRef } from "react";
import {
  Container, Row, Col, Form, Button, Dropdown, Table, Card, Modal,
  OverlayTrigger, Tooltip
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useFormik } from "formik";
import * as Yup from "yup";
import { RxCalendar } from "react-icons/rx";
import { LuDownload } from "react-icons/lu";
import { MdOutlineFileUpload } from "react-icons/md";
import IconExcel from "../../../images/dashboard/icon-excel.png";
import IconPdf from "../../../images/dashboard/icon-pdf.png";
import IconInfo from "../../../images/dashboard/icon-info.png";
import ImageNoDataFound from "../../../images/nodata_found.gif";
import DocumentUpload from "../../../components/DocumentUpload";
import DatePicker from "react-multi-date-picker";
import './styles.scss';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import apiConfig from "../../credentials/apiConfig";
import { toast } from "react-toastify";
import ReactMarkdown from 'react-markdown';
import html2pdf from 'html2pdf.js';
import PDFViewer from "./PdfViewer";
import image from "../../../images/ai-robot.gif";
import DocumentExportTools from "./DocumentExportTool";
import Loader from "../../../components/Loader";
import ReactTextTransition from "react-text-transition";


const initialMessages = [
  "AI is analyzing your data. Please wait...",
  "Hang tight! Your analysis is in progress..."
];

const repeatMessages = [
  "Fetching your results. Almost there...",
  "Great things take time. Preparing your results now...",
  "Just a little longer. Thanks for your patience!"
];

const FAR = ({ handlePrevious, engagementId, startDate, endDate, annualize, farData: farDataProp }) => {
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All Categories");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(10);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [financialData, setFinancialData] = useState([]);
  const [FARoverallAIObservations, setFARoverallAIObservations] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [farData, setFarData] = useState(null);
  const [selectedObservation, setSelectedObservation] = useState('');
  // Add this to your FAR component's state declarations
  const [engagement, setEngagement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPolling, setIsPolling] = useState(false);
  const [status, setStatus] = useState("");
  const pollingRef = useRef(null);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const [extraMessage, setExtraMessage] = useState("");

  useEffect(() => {
    let messageTimer, elapsedTimer;

    if (isPolling) {
      setCurrentMessageIndex(0);
      setElapsedSeconds(0);
      setExtraMessage("");

      messageTimer = setInterval(() => {
        setCurrentMessageIndex(prev => prev + 1);
      }, 5000);

      elapsedTimer = setInterval(() => {
        setElapsedSeconds(prev => prev + 1);
      }, 1000);
    }

    return () => {
      clearInterval(messageTimer);
      clearInterval(elapsedTimer);
    };
  }, [isPolling]);

  useEffect(() => {
    if (elapsedSeconds >= 300) {
      setExtraMessage("Thanks for your patience! Almost done.");
    } else if (elapsedSeconds >= 180) {
      setExtraMessage("Almost there. Please don’t close this tab.");
    } else if (elapsedSeconds >= 60) {
      setExtraMessage("Still working... Some files may take longer.");
    }
  }, [elapsedSeconds]);




  const getMessage = () => {
    if (currentMessageIndex < initialMessages.length) {
      return initialMessages[currentMessageIndex];
    } else {
      const loopIndex = (currentMessageIndex - initialMessages.length) % repeatMessages.length;
      return repeatMessages[loopIndex];
    }
  };


  useEffect(() => {
    if (!engagementId) return;

    const processFARData = (data) => {
      if (Array.isArray(data.FARClassifiedData) && data.FARClassifiedData.length > 0) {
        const processedData = data.FARClassifiedData.map((item, index) => ({
          id: index + 1,
          category: item.Category || "",
          group: item.Group || "",
          subGroup: item.Subgroup || "",
          account: item.AC || "",
          description: item.Description || "",
          currentYear: formatCurrency(item.Balance_CY),
          priorYear: formatCurrency(item.Balance_PY),
          change: formatCurrency(item.Change),
          percentChange: formatPercentage(item.PercentChange),
          significance: item.Significance || "Low",
          aiObservation: item.AIObservation || ""
        }));

        setFinancialData(processedData);
      }

      if (data.FARoverallAIObservations?.length > 0) {
        setFARoverallAIObservations(data.FARoverallAIObservations);
      }
    };

    const fetchFARStatus = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        const res = await axios.post(
          `${apiConfig.apiBaseURL}/getEngagementStatus/${engagementId}`,
          { module: "far" },
          {
            headers: {
              "x-api-key": apiConfig["x-api-key"],
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        const { status, data } = res.data;

        if (
          status === "completed" ||
          (data?.FARClassifiedData?.length > 0 || data?.FARoverallAIObservations?.length > 0)
        ) {
          clearInterval(pollingRef.current);
          pollingRef.current = null;
          setEngagement(res.data);
          setFarData?.({
            data: data.FARClassifiedData || [],
            FARoverallAIObservations: data.FARoverallAIObservations || ""
          });
          processFARData(data);
          setLoading(false);
          setIsPolling(false);
          setStatus("");
        }else if (status === "failed") {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
      setLoading(false);
      setIsPolling(false);
      setStatus("");
      toast.error("FAR classification failed. Please try again.");
    } else if (status === "processing" && !pollingRef.current) {
          setIsPolling(true);
          setLoading(true);
          pollingRef.current = setInterval(fetchFARStatus, 5000);
    } else if (status === "pending") {
          // FAR has never been started - show confirmation modal
          setLoading(false);
          setIsPolling(false);
          setShowConfirmationModal(true);
        }
      } catch (error) {
        console.error("Error fetching FAR status:", error);
        clearInterval(pollingRef.current);
        pollingRef.current = null;
        setLoading(false);
        setIsPolling(false);
      }
    };

    const start = async () => {
      setIsLoading(true);
      await fetchFARStatus();
      setIsLoading(false);
    };

    start();

    return () => {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
      setIsPolling(false);
    };
  }, [engagementId, status]);



  const handleShowModal = (text) => {
    setSelectedObservation(text);
    setShowModal(true);
  };

  useEffect(() => {
    // console.log("FAR component received farData:", farData);

    if (!farData) {
      setFinancialData([]);
      setFARoverallAIObservations("");
      return;
    }

    if (Array.isArray(farData)) {
      setFinancialData(farData.map(mapItem));
      setFARoverallAIObservations("");
    } else if (farData.data && Array.isArray(farData.data)) {
      setFinancialData(farData.data.map(mapItem));
      setFARoverallAIObservations(farData.FARoverallAIObservations || "");
    } else {
      // console.error("Unexpected farData format:", farData);
      setFinancialData([]);
      setFARoverallAIObservations("");
    }
  }, [farData]);

  const mapItem = (item, index) => ({
    id: index + 1,
    category: item.Category || "",
    group: item.Group || "",
    subGroup: item.Subgroup || "",
    account: item.AC || "",
    description: item.Description || "",
    currentYear: formatCurrency(item.Balance_CY),
    priorYear: formatCurrency(item.Balance_PY),
    change: formatCurrency(item.Change),
    percentChange: formatPercentage(item.PercentChange),
    significance: item.Significance || "Low",
    aiObservation: item.AIObservation || "",
  });

  const handleGenerateFAR = async ({ continueWithPreviousFile, values = {} }) => {
    const authToken = localStorage.getItem("authToken");
    setIsLoading(true);

    try {
      let dataToSend;

      if (continueWithPreviousFile) {
        dataToSend = {
          engagementId,
          continueWithPreviousFile: true,
        };
      } else {
        const formData = new FormData();
        formData.append("file", values.file);
        formData.append("engagementId", engagementId);
        formData.append("continueWithPreviousFile", false);
        formData.append("annualize", values.annualize);

        if (values.startDate) {
          formData.append("startDate", new Date(values.startDate).toISOString());
        }
        if (values.endDate) {
          formData.append("endDate", new Date(values.endDate).toISOString());
        }

        dataToSend = formData;
      }

      const response = await axios.post(
        `${apiConfig.apiBaseURL}/generateFAR`,
        dataToSend,
        {
          headers: {
            "x-api-key": apiConfig["x-api-key"],
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data?.success) {
        // Clear data to force polling to trigger
        setFarData?.(null);
        setFinancialData([]);
        setFARoverallAIObservations("");

        // Set status from API response (should be "processing" or "completed")
        setStatus(response.data?.status || "processing");

        // Polling will now begin via useEffect
      } else {
        toast.error(response.data.message || "FAR generation failed");
      }
    } catch (error) {
      console.error("FAR generation error:", error);
      toast.error(error.response?.data?.error  || "Upload failed");
    } finally {
      setIsLoading(false);
      setShowUploadModal(false);
      setShowConfirmationModal(false);
    }
  };


  const formatCurrency = (value) => {
    const num = Number(value);
    return isNaN(num) ? "$0.00" : num.toLocaleString("en-US", { style: "currency", currency: "USD" });
  };

  const formatPercentage = (value) => {
    const num = Number(value);
    return isNaN(num) ? "0%" : `${num.toFixed(1)}%`;
  };

  const filteredData = financialData.filter((item) => {
    const matchesSearch =
      item.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.group.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.subGroup.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.significance.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesCategory = selectedCategory === "All Categories" || item.category === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  const categories = ["All Categories", ...new Set(financialData.map(item => item.category).filter(Boolean))];

  const offset = currentPage * itemsPerPage;
  const displayedData = filteredData.slice(offset, offset + itemsPerPage);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const parseUTCDate = (dateString) => {
    if (!dateString) return null;

    // Parse the UTC date but preserve the actual date components
    // Split the ISO string and get just the date part (YYYY-MM-DD)
    const dateParts = dateString.split('T')[0].split('-');
    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1; // JS months are 0-indexed
    const day = parseInt(dateParts[2], 10);

    // Create date with local timezone but preserve the date components
    const localDate = new Date(year, month, day);
    return localDate;
  };

  const uploadFormik = useFormik({
    initialValues: {
      file: "",
      startDate: startDate ? parseUTCDate(startDate) : "",
      endDate: endDate ? parseUTCDate(endDate) : "",
      annualize: annualize || false,
    },
    validationSchema: Yup.object({
      file: Yup.mixed().required("File is required"),
      startDate: Yup.date().required("Start date is required"),
      endDate: Yup.date()
        .required("End date is required")
        .min(Yup.ref("startDate"), "End date must be after start date"),
    }),
    onSubmit: (values) => {
      handleGenerateFAR({ continueWithPreviousFile: false, values });
    },
  });


  // Then modify the useEffect that handles the default start and end dates:
  useEffect(() => {
    if (startDate) {
      const parsed = parseUTCDate(startDate);
      uploadFormik.setFieldValue("startDate", parsed, false);
    }

    if (endDate) {
      const parsed = parseUTCDate(endDate);
      uploadFormik.setFieldValue("endDate", parsed, false);
    }

    // Set annualize value
    uploadFormik.setFieldValue("annualize", annualize || false);
  }, [startDate, endDate, annualize]);
  const toggleShowMore = () => setShowMore(!showMore);
  const handleSearchChange = (e) => setSearchTerm(e.target.value);
  const handleCategoryChange = (category) => setSelectedCategory(category);
  const handlePageClick = (data) => setCurrentPage(data.selected);

  const handleCloseUploadModal = () => setShowUploadModal(false);


  const handleContinueToFAR = () => {
    setShowConfirmationModal(true);
  };

  // Around line 429 in your code
  const handleUploadNewFile = () => {
    setShowConfirmationModal(false);
    uploadFormik.resetForm();
    setShowUploadModal(true);

    // Parse dates properly when opening the modal
    if (startDate) {
      const parsedStartDate = parseUTCDate(startDate);
      uploadFormik.setFieldValue("startDate", parsedStartDate, false);
    }

    if (endDate) {
      const parsedEndDate = parseUTCDate(endDate);
      uploadFormik.setFieldValue("endDate", parsedEndDate, false);
    }

    uploadFormik.setFieldValue("annualize", annualize || false);
  };

  const handleContinueWithPrevious = () => {
    // Handle continue with previous file logic
    setShowConfirmationModal(false);
  };

  const handleSaveAndExit = () => {
    navigate('/engagements');
  };


  if (status === "processing") {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 1050,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "420px",
            backgroundColor: "#fff",
            borderRadius: "16px",
            padding: "40px 20px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
            textAlign: "center",
          }}
        >
          <img
            src={image}
            alt="Processing"
            style={{
              width: "120px",
              marginBottom: "20px",
            }}
          />
          <h5 style={{ fontWeight: 500, fontSize: "18px", color: "#333" }}>
            The AI is working on it.
          </h5>
          {/* <p style={{ fontSize: "14px", color: "#666" }}>
            This might take a little time, so please be patient.
          </p> */}

          <div className='d-flex justify-content-center'>
            <ReactTextTransition>
              {getMessage()}
            </ReactTextTransition>
          </div>
          {extraMessage && (
            <p style={{ fontSize: "14px", color: "#999", marginTop: "10px" }}>
              {extraMessage}
            </p>
          )}
        </div>
      </div>
    );
  }
  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <>
      <Container fluid className="py-3 far-setup">
        <h5 className="mb-2 fw-bold">Overall Observations</h5>
        {FARoverallAIObservations ? (
          <>
            <ReactMarkdown
              components={{
                h1: ({ node, ...props }) => <h6 className="markdown-heading" {...props} />,
                h2: ({ node, ...props }) => <h6 className="markdown-heading" {...props} />,
                h3: ({ node, ...props }) => <h6 className="markdown-heading" {...props} />,
              }}
            >
              {showMore ? FARoverallAIObservations : FARoverallAIObservations.slice(0, 300) + (FARoverallAIObservations.length > 300 ? '...' : '')}
            </ReactMarkdown>

            {FARoverallAIObservations.length > 300 && (
              <span
                className="text-primary fw-bold cursor-pointer"
                onClick={toggleShowMore}
                style={{ cursor: 'pointer' }}
              >
                {showMore ? 'Show less' : 'Show more'}
              </span>
            )}
          </>
        ) : (
          <p className="text-muted">No overall observations available.</p>
        )}



        <div className="bg-white p-3 rounded mb-4">
          <Row className="mb-3 credential-page filter-block">
            <Col lg={6} md={12} className="mb-2 mb-md-0 d-flex search">
              <Form.Control
                type="search"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
                className="me-2"
                style={{ padding: '10px 30px' }}
              />
              <div className="d-flex ms-2 filter">
                <span className="me-2 fw-bold my-auto" style={{ fontSize: '14px' }}>Filters</span>
                <Dropdown>
                  <Dropdown.Toggle className="w-100 text-start border" style={{ padding: '10px 30px', backgroundColor: '#E7EFF8', color: '#677289' }}>
                    {selectedCategory}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {categories.map((category, index) => (
                      <Dropdown.Item
                        key={index}
                        onClick={() => handleCategoryChange(category)}
                      >
                        {category}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
            <Col lg={6} md={12} className="d-flex justify-content-end mb-2 mb-md-0 actions">
              <DocumentExportTools
                engagementId={engagementId}
                documentType="far"
                documentData={farData?.data || financialData}
                observationsText={FARoverallAIObservations}
                showViewOptions={true}
                showDownloadOptions={true}
              />

              <Button variant="dark" onClick={handleUploadNewFile} style={{ padding: '10px 30px' }}><MdOutlineFileUpload size={20} /> Upload</Button>

            </Col>


          </Row>

          {filteredData.length > 0 ? (
            <div className="table-responsive">
              <Table hover responsive style={{ border: "2px solid #E7ECF1" }}>
                <thead className="bg-light">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th className="text-light py-3">Category</th>
                    <th className="text-light py-3">Group</th>
                    <th className="text-light py-3">Sub Group</th>
                    <th className="text-light py-3">Account</th>
                    <th className="text-light py-3">Current Year</th>
                    <th className="text-light py-3">Prior Year</th>
                    <th className="text-light py-3">Change</th>
                    <th className="text-light py-3">% Change</th>
                    <th className="text-light py-3">Significance</th>
                    <th className="text-light py-3">AI Observation</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedData.map((item) => (
                    <tr key={item.id}>
                      <td className="text-light align-middle">{item.category}</td>
                      <td className="text-light align-middle">{item.group}</td>
                      <td className="text-light align-middle">{item.subGroup}</td>
                      <td className="text-light align-middle">  <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip className="custom-tooltip">
                            {item.description}
                          </Tooltip>
                        }
                      >
                        <span className="text-light ">{item.account}</span>
                      </OverlayTrigger></td>
                      <td className="text-light align-middle">{item.currentYear}</td>
                      <td className="text-light align-middle">{item.priorYear}</td>
                      <td className={item.change.includes('-') ? 'text-danger align-middle' : 'text-success align-middle'}>
                        {item.change}
                      </td>
                      <td className={item.percentChange.includes('-') ? 'text-danger align-middle' : 'text-success align-middle'}>
                        {item.percentChange}
                      </td>
                      <td className="align-middle">
                        <span className={`badge ${item.significance === 'High' ? 'bg-danger' :
                          item.significance === 'Medium' ? 'bg-warning text-dark' :
                            'bg-secondary'
                          }`}>
                          {item.significance}
                        </span>
                      </td>
                      {/* <td className="text-light">{item.aiObservation}</td> */}
                      <td className="text-light pt-4">
                        <>
                          {`${item.aiObservation.slice(0, 100)}${item.aiObservation.length > 100 ? '...' : ''}`}
                          {item.aiObservation.length > 100 && (
                            <span
                              className="text-primary fw-bold"
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleShowModal(item.aiObservation)}
                            >
                              more
                            </span>
                          )}
                        </>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <div className="text-center py-4">
              <img src={ImageNoDataFound} alt="icon" />
              <p className="fw-bold text-dark mb-0">No matching records found</p>
            </div>
          )}

          {filteredData.length > 0 && (
            <Row className="d-flex justify-content-between align-items-center">
              <Col md={6}>
                <p>
                  Showing: {Math.min(offset + 1, filteredData.length)}–{Math.min(offset + itemsPerPage, filteredData.length)} of {filteredData.length}
                </p>
              </Col>
              <Col md={6} className="d-flex justify-content-end">
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  pageCount={totalPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={2}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={currentPage}
                />
              </Col>
            </Row>
          )}
        </div>
      </Container>

      <Container fluid className="px-0 setup-footer">
        <Card className="h-100 py-4 px-3 mt-3" style={{ border: "2px solid #ECEEF5" }}>
          <div className="d-flex justify-content-between mt-3 all-buttons">
            <div>
              <Button type='button' variant="outline-primary" className="px-5 py-3 me-3" onClick={handleSaveAndExit}>
                Save & Exit
              </Button>

              <Button variant="outline-primary" className="px-5 py-3 me-3" onClick={handlePrevious}>
                Back to File Room
              </Button>
            </div>
            {/* 
            <div>
              <Button variant="primary" className="px-5 py-3" onClick={goToDocumentSummary}>
                Continue to Document Summary
              </Button>
            </div> */}
          </div>
        </Card>
      </Container>

      {/* FAR File Upload Confirmation Modal */}
      <Modal
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        centered
        dialogClassName="upload-confirmation-modal"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">FAR File Upload Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Do you want to continue with the previously uploaded file, or do you want to upload the final current-year trial balance file?</p>
          <div className="d-flex justify-content-between mt-4">
            <Button
              variant="outline-primary"
              className="px-4 py-2 fw-bold"
              onClick={() => handleGenerateFAR({ continueWithPreviousFile: true })}
              disabled={isLoading}
            >
              Continue with Previous File
            </Button>
            <Button
              variant="primary"
              className="px-4 py-2"
              onClick={() => {
                setShowConfirmationModal(false);

                const parsedStart = parseUTCDate(startDate);
                const parsedEnd = parseUTCDate(endDate);

                uploadFormik.resetForm({
                  values: {
                    file: "",
                    startDate: parsedStart,
                    endDate: parsedEnd,
                    annualize: annualize || false
                  }
                });

                setShowUploadModal(true);
              }}
              disabled={isLoading}
            >
              Upload New File
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Upload New File Modal */}
      <Modal
        show={showUploadModal}
        onHide={handleCloseUploadModal}
        centered
        dialogClassName="upload-new-file-modal credential-page"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Upload New File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={uploadFormik.handleSubmit}>
            {/* File Upload Component */}
            <DocumentUpload
              formik={uploadFormik}
              name="file"
              acceptedTypes={{
                "text/csv": [".csv"],
                "application/vnd.ms-excel": [".xls"],
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
              }}
              label=" "
            />

            <Form.Group className="mb-3 mt-4 position-relative">
              <Form.Label>Start Date</Form.Label>
              <DatePicker
                value={uploadFormik.values.startDate}
                onChange={(date) => {
                  uploadFormik.setFieldValue("startDate", date);
                }}
                inputClass="form-control"
                placeholder="MM/DD/YYYY"
                format="MM/DD/YYYY"
                disabled={uploadFormik.values.annualize}
              />
              <RxCalendar className="position-absolute end-0 translate-middle-y me-2 text-light" size="20px" style={{ top: "67%" }} />
              {uploadFormik.touched.startDate && uploadFormik.errors.startDate ? (
                <div className="text-danger mt-1">{uploadFormik.errors.startDate}</div>
              ) : null}
            </Form.Group>

            <Form.Group className="mb-3 position-relative">
              <Form.Label>End Date</Form.Label>
              <DatePicker
                value={uploadFormik.values.endDate}
                onChange={(date) => {
                  uploadFormik.setFieldValue("endDate", date);
                }}
                inputClass="form-control"
                placeholder="MM/DD/YYYY"
                format="MM/DD/YYYY"
                disabled={uploadFormik.values.annualize}
              />
              <RxCalendar className="position-absolute end-0 translate-middle-y me-2 text-light" size="20px" style={{ top: "67%" }} />
              {uploadFormik.touched.endDate && uploadFormik.errors.endDate ? (
                <div className="text-danger mt-1">{uploadFormik.errors.endDate}</div>
              ) : null}
            </Form.Group>

            <Form.Group className="mb-3 d-flex">
              <Form.Check
                type="checkbox"
                id="annualize"
                label="Do you want to Annualize?"
                checked={uploadFormik.values.annualize}
                onChange={(e) => {
                  const checked = e.target.checked;
                  uploadFormik.setFieldValue("annualize", checked);
                }}
                name="annualize"
              />
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="button-tooltip-2">Annualizing allows you to project full-year
                  results from partial-year data.</Tooltip>}
              >
                <img className="my-auto mx-2" src={IconInfo} alt="info" style={{ cursor: "pointer", width: '18px', height: '18px' }} />
              </OverlayTrigger>
            </Form.Group>

            <div className="d-flex justify-content-end mt-4">
              <Button
                variant="outline-primary"
                className="me-2 px-3"
                onClick={handleCloseUploadModal}
                disabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                type="submit"
                className="px-3"
                disabled={isLoading}
              >
                {isLoading ? "Uploading..." : "Upload"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="mb-0 fw-bold">AI Observation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-light">
          {selectedObservation}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};


export default FAR;
